<template>
  <i
    :class="_class"
    v-html="svgStr"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import svgMap from './svg.json';

const name = 'ten-icon';
let iconId = 0;

export default {
  name,
  props: {
    /**
     * 图标类型
     */
    icon: String,
  },
  data() {
    return {
      svgStr: '',
    };
  },
  computed: {
    _class() {
      return [
        name,
        {
          [`${name}--${this.icon}`]: this.icon,
        },
      ];
    },
  },
  watch: {
    icon: {
      handler() {
        this.svgStr = this.getSvgStr();
      },
      immediate: true,
    },
  },
  methods: {
    getSvgStr() {
      let svgStr = svgMap[this.icon];
      if (svgStr) {
        const ids = [];
        svgStr.replace(/id="(\w+)"/g, (idDef, id) => {
          ids.push(id);
        });
        if (ids.length > 0) {
          ids.forEach((id) => {
            svgStr = svgStr.replace(new RegExp(id, 'g'), `id${iconId}`);
            iconId += 1;
          });
        }
      } else {
        svgStr = '<svg></svg>';
      }
      return svgStr;
    },
  },
};
</script>
